import { useEffect, useState, useSyncExternalStore } from 'react';
import { isStale } from './canonical';
import { getEntry, subscribe } from './canonicalStore';

/**
 * The canonical snapshot for a session, or `snapshot: null` when the API has
 * not offered one (its charger-UX mode is off) — the caller then renders what
 * it always has.
 *
 * `stale` turns true by itself when nothing has been heard for longer than
 * the API's freshness window; no new data is needed for it to change.
 */
export function useCanonicalSession(sessionUid) {
  const entry = useSyncExternalStore(subscribe, () => getEntry(sessionUid), () => null);
  const [now, setNow] = useState(() => Date.now());

  const seconds = Number(entry?.snapshot?.freshness?.staleAfterSeconds);
  useEffect(() => {
    if (!entry || !Number.isFinite(seconds) || seconds <= 0) return undefined;
    const id = setInterval(() => setNow(Date.now()), Math.min(15000, Math.max(1000, (seconds * 1000) / 3)));
    return () => clearInterval(id);
  }, [entry, seconds]);

  const snapshot = entry?.snapshot ?? null;
  const receivedAt = entry?.receivedAt ?? null;
  return {
    snapshot,
    receivedAt,
    stale: isStale(snapshot, receivedAt, Math.max(now, Date.now())),
  };
}
